class SelectedFile {
    constructor(
        id,
        sizeAsString,
        uploadedFile,
        errorData = null,
    ) {
        this.id = id;
        this.sizeAsString = sizeAsString;
        this.uploadedFile = uploadedFile;
        this.errorData = errorData;
    }

    getId() {
        return this.id;
    }

    getSizeAsString() {
        return this.sizeAsString;
    }

    getUploadedFile() {
        return this.uploadedFile;
    }

    hasErrors() {
        return this.errorData !== null;
    }

    getErrorData() {
        return this.errorData;
    }

    setErrorData(errorData) {
        this.errorData = errorData;
    }
}

export default SelectedFile;
